export const mixinTasks = {
	computed: {
		listProcessing() {
			const result = [];
			if (this.task) {
				for(let i = 0; i < this.task.realizators.length; i++) {
					result.push(this.task.realizators[i])
					if(i >= 2) {
						break;
					}
				}
			}
			return result
		}
	},
	methods: {
		nameAvatar(name) {
			let replaceName = name.replace(/[^А-Я]/g, "")
			return replaceName
		},
		handlerStyleTags(task) {
			if(task.order_id){
				return 'tags-style-order_id'
			}
			if(task.company_id){
				return 'tags-style-company_id'
			}
			if(task.order_service_id){
				return 'tags-style-order_service_id'
			}
			if(task.finance_id) {
				return 'tags-style-finance_id'
			}
			return 'tags-style-notification'
		},
		handlerStyleBackgroundTags(task) {
			if(task.order_id){
				return 'tags-style-bg-order_id'
			}
			if(task.company_id){
				return 'tags-style-bg-company_id'
			}
			if(task.order_service_id){
				return 'tags-style-bg-order_service_id'
			}
			if(task.finance_id) {
				return 'tags-style-bg-finance_id'
			}
			return 'tags-style-bg-notification'
		},
		handlerTypeTaskTag(task) {
			if(task.order_id){
				return 'Заказ'
			}
			if(task.company_id){
				return 'Компания'
			}
			if(task.order_service_id){
				return 'Услуга'
			}
			if(task.finance_id){
				return 'Финансы'
			}
			return 'Напоминание'
		},
		handlerTypeReferenceId(id) {
			if(id == 405){return 'Связь'}
			if(id == 404){return 'Встреча'}
			if(id == 547){return 'КП'}
			if(id == 548){return 'Договор'}
			if(id == 406){return 'Другое'}
		}
	}
}